// removed by extract-text-webpack-plugin
module.exports = {"view":"View__view___1nr7V","view-no-padding":"View__view-no-padding___2EkgB View__view___1nr7V"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/View.scss
// module id = 554
// module chunks = 0